export const SharedDataPermissions = {
  viewDashboard: {
    permissionsId: "94add514-df89-4052-9eac-04940936ce0c",
    permissionsName: "view Dashboard",
    description: null,
    componentsId: null,
    components: null,
  },
  ManageConfiguration: {
    permissionsId: "b5d4f7e1-dd8c-4541-91d8-955cc9805636",
    permissionsName: "Manage configuration",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewLead: {
    permissionsId: "309bd783-b30a-4d81-9b1b-968db6967316",
    permissionsName: "view Lead",
    description: null,
    componentsId: null,
    components: null,
  },
};
